export default __webpack_public_path__ + "static/media/2234.394e6edb.png";